/* @flow */

import currentSite from 'site/currentSite';

export default function prependLocale(path: string): string {
  const locale = __LOCALE__;
  const siteLocale = currentSite().locale;

  if (locale === siteLocale) {
    return path;
  } else {
    return ['/', locale, path].join('');
  }
}
